<ng-container *ngIf="userService?.getUser()?.IsAuthenticated; else unauthenticatedHeader">
  <div class="pt-65"></div>
  <header boiApplyCssOnScrollDirective [scrollOffSet]="65" cssClass="animation" class="vo-header position-fixed">
    <div
      class="vo-central-content h-100 w-100 d-flex align-items-center justify-content-between position-relative px-md-30"
    >
      <div class="logo cursor-pointer" (click)="goToCaseHub()"></div>

      <div class="vo-header__customer d-none heading-regular d-md-flex align-items-center word-break vo-link">
        <span class="vo-icon vo-dark-house-icon vo-icon--20 mr-5"></span>
        <span
          class="vo-body-regular-16 vo-left-mobile-menu__fullname vo-link vo-dark-link"
          [innerHtml]="referenceDataLabels.Dashboard | localizeLabel"
          (click)="goToCaseHub()"
        ></span>
      </div>

      <div
        class="vo-icon vo-icon-burger vo-left-mobile-menu__open-button ml-15 d-md-none"
        (click)="toogleLeftMenu()"
      ></div>

      <div class="d-md-flex align-items-center justify-content-between d-none">
        <boi-messages-notifications *ngIf="isUserProfileCompleteAndValid()"></boi-messages-notifications>

        <a
          class="vo-link vo-dark-link fs-13 mr-15"
          [innerHtml]="referenceDataLabels.MyProfile | localizeLabel"
          (click)="goToUserProfile()"
        ></a>
        <a
          class="vo-link vo-dark-link fs-13 mr-15"
          (click)="goToHelpCenter()"
          [innerHtml]="referenceDataLabels.HelpCentre | localizeLabel"
        ></a>

        <!-- the permissions for the link bellow will be threated in another task -->
        <a
          class="vo-link vo-dark-link fs-13 mr-15"
          (click)="goToAccessController()"
          [innerHtml]="referenceDataLabels.Admin | localizeLabel"
          [boiPermissionChecker]="[userPermissions.ManageCaseAdministrator]"
        ></a>
        <a
          id="gtag-logout"
          class="vo-link vo-dark-link fs-13"
          (click)="logout()"
          [innerHtml]="referenceDataLabels.Logout | localizeLabel"
        ></a>
      </div>

      <boi-messages-notifications class="d-md-none d-block cursor-pointer" *ngIf="isUserProfileCompleteAndValid()">
      </boi-messages-notifications>
    </div>

    <div class="vo-left-mobile-menu position-absolute" [class.vo-left-mobile-menu--opened]="isleftMenuOpened">
      <div class="d-flex justify-content-between align-items-end mx-30 mt-30 mb-50">
        <div class="d-flex flex-column">
          <span
            class="vo-heading-regular-16 text-grey-2-color mb-5"
            [innerHtml]="referenceDataLabels.Welcome | localizeLabel"
          ></span>
          <span
            class="vo-heading-regular-16 vo-left-mobile-menu__fullname"
            [innerHtml]="userService.getUser().FullName"
          ></span>
        </div>
        <div class="vo-left-mobile-menu__close vo-icon vo-icon--32 mb-n5 mr-n5" (click)="toogleLeftMenu()"></div>
      </div>

      <div
        class="vo-left-mobile-menu__item px-30 py-15"
        [innerHtml]="referenceDataLabels.Dashboard | localizeLabel"
        (click)="goToCaseHub()"
        routerLinkActive="vo-left-mobile-menu__item--active"
      ></div>

      <div
        class="vo-left-mobile-menu__item px-30 py-15"
        [innerHtml]="referenceDataLabels.MyProfile | localizeLabel"
        [routerLink]="[
          applicationHostTypeService.getCode(),
          stateService.getUserProfileState(),
          userService.getUser().UserId
        ]"
        routerLinkActive="vo-left-mobile-menu__item--active"
      ></div>

      <div
        class="vo-left-mobile-menu__item px-30 py-15"
        [innerHtml]="referenceDataLabels.HelpCentre | localizeLabel"
        (click)="goToHelpCenter()"
        routerLinkActive="vo-left-mobile-menu__item--active"
      ></div>

      <div
        class="vo-left-mobile-menu__item px-30 py-15"
        [innerHtml]="referenceDataLabels.Admin | localizeLabel"
        [routerLink]="[applicationHostTypeService.getCode(), stateService.getAccessControllerState()]"
        routerLinkActive="vo-left-mobile-menu__item--active"
        [boiPermissionChecker]="[userPermissions.ManageCaseAdministrator]"
      ></div>

      <div
        class="vo-left-mobile-menu__item px-30 py-15"
        [innerHtml]="referenceDataLabels.Logout | localizeLabel"
        (click)="toogleLeftMenu(); logout()"
      ></div>

      <boi-messages-notifications [isLeftMenuMessageNotification]="true" *ngIf="isUserProfileCompleteAndValid()">
      </boi-messages-notifications>
    </div>
  </header>

  <div class="vo-header__profile-link heading-regular d-md-none w-100 text-center p-15"></div>
</ng-container>

<ng-template #unauthenticatedHeader>
  <ng-container *ngIf="headerService.showUnauthenticatedHeader">
    <div class="pt-65"></div>
    <header boiApplyCssOnScrollDirective [scrollOffSet]="65" cssClass="animation" class="vo-header position-fixed">
      <div class="vo-central-content h-100 w-100 d-flex align-items-center position-relative px-md-30">
        <div
          class="logo logo--unauthenticated cursor-pointer"
          (click)="headerService.isMakePaymentContext ? refreshMakePayment() : goToLogin()"
        ></div>
        <span class="flex-auto"></span>
        <ng-container *ngIf="!headerService.IsOnlineOfferState; else onlineOfferState">
          <ng-container *ngIf="headerService.isHelpCentreLinkVisible">
            <a
              class="vo-link vo-dark-link fs-13 mr-15 d-none d-md-block"
              (click)="goToHelpCenter()"
              [innerHtml]="referenceDataLabels.HelpCentre | localizeLabel"
            ></a>
            <span class="vo-link fs-13 d-block d-md-none vo-header__help" (click)="goToHelpCenter()">?</span>
          </ng-container>
        </ng-container>
        <ng-template #onlineOfferState>
          <div
            *ngIf="headerService.IsOnlineOfferState"
            (click)="closeOnlineOfferSession()"
            class="vo-icon vo-icon-x vo-icon--30 ml-auto mr-15 cursor-pointer"
          ></div>
        </ng-template>
      </div>
    </header>
  </ng-container>
</ng-template>

<div *ngIf="headerTitle" class="sub-header w-100">
  <div class="vo-central-content w-100 px-30 text-center text-md-left">
    <span class="vo-heading-regular-20 text-white-color" [innerHtml]="headerTitle | localizeLabel"></span>
  </div>
</div>

<ng-container *ngIf="isCookieWarningVisible">
  <boi-cookie-warning-banner></boi-cookie-warning-banner>
</ng-container>
